import { BrowserModule } from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { ViewsModule } from './views/views.module';
import { TranslateModule } from '@ngx-translate/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HttpClientModule } from '@angular/common/http';
import { AngularFireModule } from '@angular/fire';
import { environment } from '../environments/environment';
import { LayoutContainersModule } from './containers/layout/layout.containers.module';
import {API_BASE_URL, ConfigFactory, ConfigService} from "./shared/config.service";

@NgModule({
  imports: [
    BrowserModule,
    ViewsModule,
    AppRoutingModule,
    LayoutContainersModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot(),
    HttpClientModule,
    AngularFireModule.initializeApp(environment.firebase),

  ],
  declarations: [
    AppComponent
  ],
  providers: [
    ConfigService,
    { provide: "CONFIG.JSON", useValue: "./assets/config.json" },
    { provide: "BASE-API-VARIABLE", useValue: "API_URL" },
    {
      provide: API_BASE_URL,
      useFactory: ConfigFactory,
      deps: [ConfigService, "CONFIG.JSON", "BASE-API-VARIABLE"],
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
